import { render, staticRenderFns } from "./configs.vue?vue&type=template&id=6e03e77c&"
import script from "./configs.vue?vue&type=script&lang=js&"
export * from "./configs.vue?vue&type=script&lang=js&"
import style0 from "./configs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports